import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
// import { extendSessionData } from "./utils/sessionUtils";
import routes from "./routes";
import Login from "./components/auth-pages/login";
import VerifyOtp from "./components/auth-pages/verify-otp";
import ProtectedRoute from "./protectedRoute";
import NotFound from "./components/not-found";
import UnAuthorized from "./components/unauthorized";
import useInactivityTimer from "./components/common/useInactivityTimer";
import { clearSession } from "./utils/sessionUtils";
import { showToastWarn } from "./components/common/toastHelper";
const App = () => {
  useEffect(() => {
    // Extend session data on component mount
    // extendSessionData();
  }, []);
  const handleLogout = () => {
    // Logic to expire the session or log the user out
    if (!["/login", "/verify-otp", "/"].includes(window.location.pathname)) {
      showToastWarn("User inactive for long time. Logging out.");
      clearSession();
      window.location.href = "/login";
    }
  };

  useInactivityTimer(handleLogout);
  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<UnAuthorized />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <ProtectedRoute
                  routeName={route.path}
                  element={route.component}
                />
              }
            />
          );
        })}
      </Routes>
    </Router>
  );
};

export default App;
